import { useState } from 'react';
import UIComponent from './uiComponent';
import { resovleContent } from './utils';
export default class UISlot extends UIComponent {
    setExternalComponent = null;
    initialExternalComponent = null;
    constructor(s) {
        super(s);
        resovleContent(this, s);
    }
    getComponent() {
        // Initialize the slot content state
        const [externalComponent, setExternalComponent] = useState(this.initialExternalComponent);
        this.setExternalComponent = setExternalComponent;
        // Render only the external component
        return externalComponent;
    }
    // Instance method for setting the slot content
    setComponent(component) {
        if (this.setExternalComponent) {
            this.setExternalComponent(component);
        }
        else {
            this.initialExternalComponent = component;
        }
    }
    // Instance method for clearing the slot content
    clearComponent() {
        this.setComponent(null);
    }
}
//# sourceMappingURL=uiSlot.js.map